export default __webpack_public_path__ + "static/media/animators.5134ecb1.png";